<template>
  <div class="vendor-invoice full-width q-pt-xl">
    <div class="text-body-3 text-secondary-5">Invoice</div>
    <div class="line"></div>

    <Grid gtc="auto auto 1fr" gap="0 var(--r-space-xxl)" class="content q-py-sp q-px-lg">
      <Grid gtc="1fr auto" gap="var(--r-space-sm)" align-items="center">
        <div class="text-body-1 text-secondary-5">Invoice number:</div>
        <div class="text-body-3 text-secondary-5">{{ data.invoice_number || 'N/A' }}</div>

        <div class="text-body-1 text-secondary-5">Voucher number:</div>
        <div class="text-body-3 text-secondary-5">{{ data.voucher_number || 'N/A' }}</div>

        <div class="text-body-1 text-secondary-5">Ref. number:</div>
        <div class="text-body-3 text-secondary-5">{{ data.reference_number || 'N/A' }}</div>
      </Grid>

      <Grid gtc="1fr auto" gap="var(--r-space-sm)" align-items="center">
        <div class="text-body-1 text-secondary-5">Issue date:</div>
        <div class="text-body-3 text-secondary-5">{{ formatDateForLocale(data.issue_date) || 'N/A' }}</div>

        <div class="text-body-1 text-secondary-5">Due date:</div>
        <div class="text-body-3 text-secondary-5">{{ formatDateForLocale(data.due_date) || 'N/A' }}</div>

        <div class="text-body-1 text-secondary-5">Invoice file:</div>
        <div class="text-body-3 text-secondary-5">
          <template v-if="data.file">
            <a href="#" class="link text-body-1 text-link-blue" @click="download(data.file.id)">
              <Grid gaf="column" align-items="center" gap="var(--r-space-xs)">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.9425 7.25H11.75V3.5C11.75 3.0875 11.4125 2.75 11 2.75H8C7.5875 2.75 7.25 3.0875 7.25 3.5V7.25H6.0575C5.39 7.25 5.0525 8.06 5.525 8.5325L8.9675 11.975C9.26 12.2675 9.7325 12.2675 10.025 11.975L13.4675 8.5325C13.94 8.06 13.61 7.25 12.9425 7.25ZM4.25 14.75C4.25 15.1625 4.5875 15.5 5 15.5H14C14.4125 15.5 14.75 15.1625 14.75 14.75C14.75 14.3375 14.4125 14 14 14H5C4.5875 14 4.25 14.3375 4.25 14.75Z"
                    fill="#269AE4"
                  />
                </svg>
                {{ data.file.name }}
              </Grid>
            </a>
          </template>

          <span v-else>N/A</span>
        </div>
      </Grid>

      <Grid style="justify-self: end; align-self: end">
        <div class="text-body-3 text-secondary-5 text-right">Amount:</div>
        <div class="text-heading-1 text-secondary-5">
          {{ data.currency }}
          {{ data.amount ? formatPrice(data.amount, 2) : '-' }}
        </div>
      </Grid>
    </Grid>

    <div class="line"></div>

    <GridTable v-if="data.items" :columns="columns" :rows="data.items" style="width: 400px">
      <template #row="{row}">
        <GridTableCell>{{ row.name }}</GridTableCell>
        <GridTableCell class="text-right">{{ data.currency }} {{ formatPrice(row.amount) }}</GridTableCell>
      </template>
    </GridTable>
  </div>
</template>

<script>
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  components: {
    GridTable,
    GridTableCell
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    columns() {
      return [
        { label: 'Subscriptions included', width: '1fr' },
        { label: 'Amount', width: '1fr', align: 'right' }
      ]
    }
  },

  methods: {
    download(id) {
      this.$store.dispatch('downloadMedia', id, { root: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.vendor-invoice {
  .line {
    height: 1px;
    width: 100%;
    background: var(--r-secondary-5);
  }
}
</style>
